import { apiGet, apiPost, apiPut, apiDelete } from "../../api/client";
import { IParameter } from "../../types";

/**
 * REST client for configuration parameters (served under `/api/settings`).
 * Replaces direct Firestore access so parameter data is read and written
 * exclusively through the API.
 */

const PARAMETER_PATH = "/api/settings/parameter";

/** Serialized parameter payload sent as a JSON request body (e.g. `Parameter.data()`). */
type ParameterPayload = Record<string, unknown>;

/** Full parameter list for a workspace (no pagination — current default). */
export const listParameters = async (
  token: string,
  workspaceId: string,
): Promise<IParameter[]> => {
  const envelope = await apiGet(token, PARAMETER_PATH, workspaceId);
  return (envelope?.data as IParameter[]) ?? [];
};

export const createParameter = async (
  token: string,
  workspaceId: string,
  parameter: ParameterPayload,
): Promise<IParameter> => {
  const envelope = await apiPost(token, PARAMETER_PATH, parameter, workspaceId);
  return envelope?.data as IParameter;
};

export const updateParameter = async (
  token: string,
  workspaceId: string,
  parameterId: string,
  parameter: ParameterPayload,
): Promise<IParameter> => {
  const envelope = await apiPut(
    token,
    `${PARAMETER_PATH}/${parameterId}`,
    parameter,
    workspaceId,
  );
  return envelope?.data as IParameter;
};

export const deleteParameter = async (
  token: string,
  workspaceId: string,
  parameterId: string,
): Promise<void> => {
  await apiDelete(token, `${PARAMETER_PATH}/${parameterId}`, workspaceId);
};
